import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate, useMsal } from "@azure/msal-react";
import AzureSignInButton from "./AzureSignInButton";
import React from "react";
import { AuthenticationResult, Configuration, PopupRequest, PublicClientApplication } from "@azure/msal-browser";
import { useLoginEventTrackers } from "../provider/useLoginEventTrackers";

export const msalConfig: Configuration = {
  auth: {
    clientId: "813b5f57-91e1-4740-a166-39154307c59c",
  },
};
export const loginRequest: PopupRequest = {
  scopes: ["User.Read"],
  prompt: "login",
};

interface AzureSignInProps {
  onAuthenticated: (result: AuthenticationResult) => Promise<void> | void;
  redirectUri?: string;
}

/**
 * Request user to sign in with their account
 */
function AzureSignIn(props: AzureSignInProps) {
  const { instance } = useMsal();
  return (
    <AzureSignInButton
      onClick={async () => {
        props.onAuthenticated(
          await instance.loginPopup({
            ...loginRequest,
            ...(props.redirectUri && { redirectUri: props.redirectUri }),
          })
        );
      }}
    />
  );
}

/**
 * Request for an access token for signed in user
 */
function RequestAzureToken(props: AzureSignInProps) {
  const { instance } = useMsal();
  const tracker = useLoginEventTrackers();
  return (
    <AzureSignInButton
      onClick={async () => {
        try {
          props.onAuthenticated(
            await instance.acquireTokenPopup({
              ...loginRequest,
              ...(props.redirectUri && { redirectUri: props.redirectUri }),
            })
          );
        } catch (e) {
          tracker.trackLoginError(e);
          throw e;
        }
      }}
    />
  );
}

/**
 * Azure SSO login button. Returns user info and JWT token.
 * @param {{onAuthenticated: (authenticationResult: AuthenticationResult) => Promise<any>}} props
 * @returns {JSX.Element}
 * @constructor
 */
function AzureSso(props: AzureSignInProps) {
  const msalInstance = new PublicClientApplication(msalConfig);
  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>
        <RequestAzureToken {...props} />
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <AzureSignIn {...props} />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
}

export default AzureSso;
